export const ANSWER_TYPES = {
  SELECTION: 'selection',
  SELECT_SINGLE: 'select-single',
  QUESTION_ANSWER: 'question-answer',
  RANKING: 'ranking',
  QUESTION_ANSWER_PHOTOS: 'question-answer-photos',
  CAPTURE_TITLE: 'capture-title',
  TOP_10: 'top-10',
  FORM_FIELD: 'form-field',
  PHOTO_ALBUM: 'photo-album',
}

export const _ = ''
